// extracted by mini-css-extract-plugin
module.exports = {"content":"TextCombinations_content__13vT_"};